module.exports = __webpack_public_path__ + "static/media/banner-img-3.c1d1e8b1.png";